import { render, staticRenderFns } from "./PopupDynamicMessage.vue?vue&type=template&id=1697dbfa&scoped=true"
import script from "./PopupDynamicMessage.vue?vue&type=script&lang=js"
export * from "./PopupDynamicMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1697dbfa",
  null
  
)

export default component.exports